export const EXCLUDED_PROPERTY_TYPES = ['garden home'];

/**
 * Remove unwanted property types from pivot table row entries.
 * We normalize label/property type to lowercase so comparisons are case-insensitive.
 */
export const filterPivotRows = (rows) => {
  if (!Array.isArray(rows)) {
    return rows;
  }

  return rows.filter((row) => {
    const label = (row?.label || '').trim().toLowerCase();
    const propertyType = (row?.property_type || '').trim().toLowerCase();
    return !EXCLUDED_PROPERTY_TYPES.includes(label) && !EXCLUDED_PROPERTY_TYPES.includes(propertyType);
  });
};
